import { render, staticRenderFns } from "./CatchGeneralCutting.vue?vue&type=template&id=4d9841a6&scoped=true"
import script from "./CatchGeneralCutting.vue?vue&type=script&lang=js"
export * from "./CatchGeneralCutting.vue?vue&type=script&lang=js"
import style0 from "./CatchGeneralCutting.vue?vue&type=style&index=0&id=4d9841a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9841a6",
  null
  
)

export default component.exports